<template>
  <el-dialog
    class="dialog-total"
    width="1100px"
    top="8vh"
    :visible.sync="show"
    :modal-append-to-body="false"
    :append-to-body="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="onDlgClose"
  >
    <div class="main">
      <div class="tablediv">
        <div class="total-title">
          <span class="OD-span1">
            订单号
            <span class="OD-span2">{{oinfo.bid}}</span>
          </span>
          <div style="float:right;clear:both;">
            <span class="OD-span3">
              下单时间 {{oinfo.createtime}}
              <span class="OD-span4">已完成</span>
            </span>
          </div>
        </div>
        <el-row class="row-style">
          <el-col :span="24" class="select-title">
            <span>设备列表</span>
          </el-col>
        </el-row>
        <div class="tablepad">
          <el-table
            :data="oinfo.bcontent"
            style="width: 100%"
            empty-text="暂无设备"
            header-row-class-name="tableHead"
            :header-cell-style="{'background-color':'#8D99AB'}"
            cell-class-name="tableTbody"
          >
            <el-table-column prop="dvsno" label="印宝编号"></el-table-column>
            <el-table-column prop="beforeValidity" label="购买前有效期">
              <template slot-scope="scope">
                <span
                  class="service"
                  :class="[scope.row.beforeValidity != '无服务'?'orange':'']"
                >{{scope.row.beforeValidity}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="afterValidity" label="购买后有效期">
              <template slot-scope="scope">
                <span class="orderdeline">{{scope.row.afterValidity}}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-row>
            <el-col :span="24" class="pad-top txt-right">
              <span class="OD-span5">
                共
                <span class="orange">{{ordersum}}</span>台印宝
              </span>
              <span class="pad-left OD-span5">
                单价
                <span class="orange">{{price}}</span>
              </span>
              <span class="pad-left OD-span5">
                购买
                <span class="orange">
                  {{gmodel=="按年" ?(amount/12).toFixed(0): amount}}
                  {{gmodel=="按年" ? "年" : "月"}}
                </span>服务
              </span>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="totalprice txt-right">
              <span class="OD-span6">
                总价
                <span class="orange">{{oinfo.bamount}}元</span>
              </span>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import util from "../components/util";
export default util.useCommon({
  data() {
    return {
      showFlg: 0, //0:初始状态 1：开启 2；关闭
      oinfo:[],
      price: 0,
      ordersum: 0,
      amount:"",
      gmodel:"",
    };
  },
  computed: {
    show: {
      get() {
        if (this.showFlg == 2) return false;
        if (this.visible) {
          this.oinfo = this.info;
          if (this.showFlg == 0) {
            this.showFlg = 1;
            return this.visible;
          }
        }
        return false;
      },
      set(val) {
        this.showFlg = val ? 1 : 2; //0:初始状态 1：开启 2；关闭
      }
    }
  },
  watch: {
    showFlg: "init"
  },
  props: {
    visible: Boolean,
    info: String   
  },
  methods: {
    onDlgClose() {
      this.showFlg = 0; //0:初始状态 1：开启 2；关闭
      this.$emit("close", { a: 1, b: 2 });
    },
    init(curVal, oldVal) {
      var v = this;
      if (curVal == 1) {
        v.nyy.userInfo = JSON.parse(localStorage.getItem("userInfo"));
        v.owner = v.nyy.userInfo.owner;
        v.corp = v.nyy.userInfo.corp;
        v.ordersum = v.oinfo.bcontent.length;
        v.gmodel = v.oinfo.bcontent[0].gmodel;
        v.amount = v.oinfo.bcontent[0].amount;
        v.query();
      } else {
        v.oinfo = "";
      }
    },
    query() {
      var v = this;
      v.dopost(
        "/order/getPrice",
        { 
          bid : v.oinfo.bid,
          gmodel: v.gmodel,
          gtype :v.oinfo.gtype
        },
        function(result) {
          if ("0000" === result.state) {
            v.price = result.body.unitprice + result.body.unitname;
          } else {
            var msg = [];
            for (var i = 0; i < result.body.length; i++) {
              msg.push(result.body[i].errmsg);
            }
            v.message("error", msg.join("<br/>"));
          }
          console.log(result);
        }
      );
    },
  },
});
</script>
<style  scoped>
.dialog-total /deep/ .el-dialog__body {
  padding-top: 20px;
  padding-bottom: 30px;

}
.dialog-total /deep/ .el-dialog__header {
  height: 0px;
  padding-top: 8px;
}
.dialog-total /deep/ .el-dialog {
  margin: 0 auto 0px;
}
.total-title {
  padding-top: 0px;
}
.main {
  overflow: auto;
}
.orderdeline {
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #4379ee;
}
.OD-span1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.OD-span2 {
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.OD-span3 {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #8295ae;
}
.OD-span4 {
  padding-left: 20px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
}
.service {
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
.OD-span5 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
}
.OD-span6 {
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  margin-top: 20px;
}
.pad-top {
  padding-top: 20px;
}
.pad-left {
  padding-left: 39px;
}
.totalprice {
  padding: 20px 0;
}
</style>